import RefData from 'ref-data';

import { capabilities } from '../Services';

// export as a function to get access to `capabilities` in the runtime
export default () => ({
  [RefData.Enum.TYPE.INTEGRATIONAPPLICATION.SAILTHRUSELFSERVE]: {
    name: 'Sailthru',
    icon: '/c/img/icons/integrations/integration_sailthru.svg',
    helpText:
      'To find your API Key and Secret, navigate to <a href="https://my.sailthru.com/settings/api_postbacks" target="_blank">Sailthru API Settings</a>.',
    fields: [
      {
        help:       'Name',
        isRequired: true,
        id:         'name',
        label:      'Name',
        type:       'input',
      },
      {
        help:        'API Key',
        isRequired:  true,
        id:          'apiKey',
        label:       'API Key',
        placeholder: 'Enter Api Key',
        validations: {
          regex: ['/^[a-zA-Z0-9]*$/'],
        },
        obscureInput:      true,
        visibleCharacters: 4,
        type:              'input',
      },
      {
        help:        'Secret',
        isRequired:  true,
        id:          'appSecret',
        label:       'Secret',
        placeholder: 'Enter Secret',
        validations: {
          regex: ['/^[a-zA-Z0-9]*$/'],
        },
        obscureInput:      true,
        visibleCharacters: 4,
        type:              'input',
      },
    ],
  },
  [RefData.Enum.TYPE.INTEGRATIONAPPLICATION.CAMPAIGNMONITOR]: {
    name: 'Campaign Monitor',
    icon: '/c/img/icons/integrations/integration_campaign_monitor.svg',
    helpText:
      'Learn <a href="https://help.campaignmonitor.com/api-keys" target="_blank">where to find your API Client ID and API Key</a>',
    fields: [
      {
        help:       'Name',
        isRequired: true,
        id:         'name',
        label:      'Name',
        type:       'input',
      },
      {
        help:        'API Client ID',
        isRequired:  true,
        id:          'apiKey',
        label:       'API Client ID',
        placeholder: 'Enter API Client ID',
        validations: {
          regex: ['/^[a-zA-Z0-9]*$/'],
        },
        obscureInput:      true,
        visibleCharacters: 4,
        type:              'input',
      },
      {
        help:              'API Key',
        isRequired:        true,
        id:                'appSecret',
        label:             'API Key',
        placeholder:       'Enter Api Key',
        obscureInput:      true,
        visibleCharacters: 4,
        type:              'textarea',
      },
    ],
  },
  [RefData.Enum.TYPE.INTEGRATIONAPPLICATION.EMMA]: {
    name: 'Emma',
    icon: '/c/img/icons/integrations/integration_emma.svg',
    helpText:
      'Learn how to generate your <a href="https://help.myemma.com/s/article/Our-open-API" target="_blank">API keys</a> and where to find your <a href="https://help.myemma.com/s/article/Explanation-of-Emma-HQ-admin-tools" target="_blank">account ID</a>',
    fields: [
      {
        help:       'Name',
        isRequired: true,
        id:         'name',
        label:      'Name',
        type:       'input',
      },
      {
        help:        'Api Public Key',
        isRequired:  true,
        id:          'apiKey',
        label:       'API Public Key',
        placeholder: 'Enter Api Public Key',
        validations: {
          regex: ['/^[a-zA-Z0-9]*$/'],
        },
        obscureInput:      true,
        visibleCharacters: 4,
        type:              'input',
      },
      {
        help:        'Api Private Key',
        isRequired:  true,
        id:          'appSecret',
        label:       'Api Private Key',
        placeholder: 'Enter Api Private Key',
        validations: {
          regex: ['/^[a-zA-Z0-9]*$/'],
        },
        obscureInput:      true,
        visibleCharacters: 4,
        type:              'input',
      },
      {
        help:        'Account Id',
        isRequired:  true,
        id:          'appId',
        label:       'Account ID',
        placeholder: 'Enter Account Id',
        type:        'input',
      },
    ],
  },
  [RefData.Enum.TYPE.INTEGRATIONAPPLICATION.OPENIDONLOAD]: {
    name:       'OpenId credentials',
    capability: capabilities.OPENID_ONLOAD_INTEGRATION,
    icon:       '/c/img/icons/integrations/integration_openid.svg',
    helpText:   'OpenID credentials',
    fields:     [
      {
        help:       'Name',
        isRequired: true,
        id:         'name',
        label:      'Name',
        type:       'input',
      },
      {
        help:        'Client ID',
        isRequired:  true,
        id:          'appId',
        label:       'Client ID',
        placeholder: 'Enter Client ID',
        type:        'input',
      },
      {
        help:              'Client Secret',
        isRequired:        true,
        id:                'appSecret',
        label:             'Client Secret',
        placeholder:       'Enter the Client Secret',
        obscureInput:      true,
        visibleCharacters: 4,
        type:              'input',
      },
      {
        help:        'Auth provider URL',
        isRequired:  false,
        id:          'url',
        label:       'Auth provider URL',
        placeholder: 'Root URL for the provider without trailing slashes',
        type:        'input',
      },
      {
        help:        'Scopes',
        isRequired:  true,
        id:          'permissions',
        label:       'Scopes',
        placeholder: 'openid profile',
        type:        'input',
      },
      {
        help:        'Tenant',
        isRequired:  false,
        id:          'namespace',
        label:       'Tenant',
        placeholder: '',
        type:        'input',
      },
      {
        help:       'Provider config type',
        isRequired: false,
        id:         'providerCopy',
        label:      'Provider config type',
        placeholder:
          'Can be: OpenIDConnectAuth, GigyaOpenIDConnectAuth, KeycloakAuth, SalesforceAuth, ShopifyAuth or Custom providing a json',
        type: 'textarea',
      },
      {
        help:        'Internal On-Load Secret',
        isRequired:  true,
        id:          'apiKey',
        label:       'Internal On-Load Secret',
        placeholder: 'Generate a new random key',
        validations: {
          regex: ['/^[a-zA-Z0-9]*$/'],
        },
        obscureInput:      true,
        visibleCharacters: 4,
        type:              'input',
      },
    ],
  },
  [RefData.Enum.TYPE.INTEGRATIONAPPLICATION.MOMENTS]: {
    name:       'Moments',
    capability: capabilities.EVENT_STREAM_INTEGRATION,
    icon:       '/c/img/icons/integrations/integration_moments.svg',
    helpText:
      'Learn <a href="https://getstarted.meetmarigold.com/moments/Content/Moments/Integration/IntegrateMoments.htm" target="_blank">how to set up Marigold Moments</a> and <a href="https://getstarted.meetmarigold.com/moments/Content/Moments/Integration/SDK.htm" target="_blank">find your credentials</a>.',
    fields: [
      {
        help:       'Name',
        isRequired: true,
        id:         'name',
        label:      'Name',
        type:       'input',
      },
      {
        help:        'SDK API Key',
        isRequired:  true,
        id:          'appId',
        label:       'SDK API Key',
        placeholder: 'Enter SDK API Key',
        type:        'input',
      },
    ],
  },
  [RefData.Enum.TYPE.INTEGRATIONAPPLICATION.ADOBECOMMERCE]: {
    name:       'Adobe Commerce',
    capability: capabilities.ADOBE_COMMERCE_PRODUCT_QUIZ,
    icon:       '/c/img/icons/integrations/integration_adobecommerce.svg',
    helpText:
      'Learn how to generate your <a href="https://developer.adobe.com/commerce/marketplace/guides/eqp/v1/access-keys/" target="_blank" rel="noopener noreferrer">API Keys</a> and find your <a href="https://experienceleague.adobe.com/en/docs/commerce-admin/stores-sales/site-store/store-urls" target="_blank" rel="noopener noreferrer">Store URL.</a>',
    fields: [
      {
        help:       'Name',
        isRequired: true,
        id:         'name',
        label:      'Name',
        type:       'input',
      },
      {
        help:       'Store domain',
        isRequired: true,
        id:         'url',
        label:      'Store domain',
        type:       'input',
      },
      {
        help:       'Store id',
        isRequired: false,
        id:         'appId',
        label:      'Store id (optional)',
        type:       'input',
      },
      {
        help:        'Api Public Key',
        isRequired:  true,
        id:          'apiKey',
        label:       'API Public Key',
        placeholder: 'Enter Api Public Key',
        validations: {
          regex: ['/^[a-zA-Z0-9]*$/'],
        },
        obscureInput:      true,
        visibleCharacters: 4,
        type:              'input',
      },
      {
        help:        'Api Private Key',
        isRequired:  true,
        id:          'appSecret',
        label:       'Api Private Key',
        placeholder: 'Enter Api Private Key',
        validations: {
          regex: ['/^[a-zA-Z0-9]*$/'],
        },
        obscureInput:      true,
        visibleCharacters: 4,
        type:              'input',
      },
      {
        help:        'Consumer Key Description',
        isRequired:  true,
        id:          'consumerKey',
        label:       'Consumer Key',
        placeholder: 'Please enter the Consumer Key',
        validations: {
          regex: ['/^[a-zA-Z0-9]*$/'],
        },
        obscureInput:      true,
        visibleCharacters: 4,
        type:              'input',
      },
      {
        help:        'Consumer Secret',
        isRequired:  true,
        id:          'consumerSecret',
        label:       'Consumer Secret',
        placeholder: 'Please enter the Consumer Secret',
        validations: {
          regex: ['/^[a-zA-Z0-9]*$/'],
        },
        obscureInput:      true,
        visibleCharacters: 4,
        type:              'input',
      },
    ],
  },
  [RefData.Enum.TYPE.INTEGRATIONAPPLICATION.SHOPIFYEXTDATA]: {
    name: 'Shopify',
    icon: 'c/img/icons/integrations/integration_shopify.svg',
    helpText:
      'Learn <a href="https://getstarted.meetmarigold.com/grow/Content/Grow/create_publish/create_an_experience/How-to-Set-up-a-Shopify-Product-Quiz.htm?Highlight=shopify#InstalltheHeadlessappbyShopify" target="_blank" rel="noopener noreferrer">where to find your Shopify store ID and private access token</a>.',
    fields: [
      {
        help:       'Name',
        isRequired: true,
        id:         'name',
        label:      'Name',
        type:       'input',
      },
      {
        help:        'Your Shopify store ID',
        isRequired:  true,
        id:          'appId',
        label:       'Shopify store ID',
        placeholder: 'Enter your Shopify store ID',
        type:        'input',
      },
      {
        help:        'Your storefront private access token',
        isRequired:  true,
        id:          'appSecret',
        label:       'Private access token',
        placeholder: 'Enter your private access token',
        type:        'secret',
      },
    ],
  },
});
